module.exports = __webpack_public_path__ + "img/classify.4191591f.png";